import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import Layout from './layouts'

const ArtworksLayout = () => (
  <NavigationLayout dataApp='userartworks'>
    <Layout />
  </NavigationLayout>
)

export default ArtworksLayout
